export default "__VITE_ASSET__DF_XI9M0__"